import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useFetchUserProfile } from 'actions/userProfile';
import { useFetchComments, usePostComment } from 'actions/comments';
import { useFetchMyContentCommentSubscription, useUpdateMyContentCommentSubscription } from 'actions/contentCommentSubscriptions';
import CheckboxOption from 'components/CheckboxOption';
import Stack from 'components/Stack';
import Landmark from 'components/Landmark';
import EmptyStateController from 'components/EmptyStateController';
import Text from 'components/Text';
import Box from 'components/Box';
import Button from 'components/Button';
import CommentsTitle from './CommentsTitle';
import CommentForm from '../CommentForm';
import Comment from '../Comment';
import { CommentSizesContext } from '../Context/CommentSizesContext';
import { CommentAvatarWrapper } from '../Shared';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function Comments(_ref) {
  var readOnly = _ref.readOnly,
    size = _ref.size,
    canSubscribe = _ref.canSubscribe,
    totalCount = _ref.totalCount,
    contentId = _ref.contentId,
    _ref$contentType = _ref.contentType,
    contentType = _ref$contentType === void 0 ? 'asset' : _ref$contentType;
  var _useTranslation = useTranslation(),
    _useTranslation2 = _slicedToArray(_useTranslation, 1),
    t = _useTranslation2[0];
  var _useState = useState('idle'),
    _useState2 = _slicedToArray(_useState, 2),
    submissionStatus = _useState2[0],
    setSubmissionStatus = _useState2[1];
  var _useFetchMyContentCom = useFetchMyContentCommentSubscription({
      contentId: contentId
    }),
    subscription = _useFetchMyContentCom.subscription,
    isSubscriptionLoading = _useFetchMyContentCom.isLoading;
  var _useUpdateMyContentCo = useUpdateMyContentCommentSubscription({
      contentId: contentId
    }),
    updateMyContentCommentSubscription = _useUpdateMyContentCo.updateMyContentCommentSubscription;
  var _useFetchUserProfile = useFetchUserProfile(),
    userProfile = _useFetchUserProfile.data,
    isUserProfileLoading = _useFetchUserProfile.isLoading,
    isUserProfileError = _useFetchUserProfile.isError;
  var _useFetchComments = useFetchComments({
      contentId: contentId,
      includedRepliesCount: 5,
      limit: 30
    }),
    comments = _useFetchComments.items,
    hasNextPage = _useFetchComments.hasNextPage,
    fetchNextPage = _useFetchComments.fetchNextPage,
    areCommentsLoading = _useFetchComments.isLoading,
    isCommentsError = _useFetchComments.isError;
  function onSuccess() {
    setSubmissionStatus('success');
  }
  var _usePostComment = usePostComment({
      contentType: contentType,
      contentId: contentId,
      onSuccess: onSuccess,
      onError: function onError() {
        return setSubmissionStatus('error');
      }
    }),
    postComment = _usePostComment.postComment;
  function submitComment(_x) {
    return _submitComment.apply(this, arguments);
  }
  function _submitComment() {
    _submitComment = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(message) {
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 1;
            return postComment(message);
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _submitComment.apply(this, arguments);
  }
  return /*#__PURE__*/_jsx(CommentSizesContext.Provider, {
    value: size,
    children: /*#__PURE__*/_jsx("section", {
      "aria-label": t('comments_title'),
      children: /*#__PURE__*/_jsxs(Stack, {
        spacing: "m",
        children: [/*#__PURE__*/_jsxs(Stack, {
          spacing: "xxs",
          children: [/*#__PURE__*/_jsx(CommentsTitle, {
            children: totalCount > 0 ? t('comment_count', {
              count: totalCount
            }) : t('comments_title')
          }), !readOnly && canSubscribe && /*#__PURE__*/_jsx(CheckboxOption, {
            disabled: isSubscriptionLoading,
            checked: subscription === null || subscription === void 0 ? void 0 : subscription.isSubscribed,
            onChange: function onChange(event) {
              return updateMyContentCommentSubscription(event.target.checked);
            },
            label: t('actions_subscribe_to_comment_notifications'),
            id: "notification-toggle",
            fontSize: "xs"
          })]
        }), /*#__PURE__*/_jsx(EmptyStateController, {
          isLoading: isUserProfileLoading || areCommentsLoading,
          isError: isUserProfileError || isCommentsError,
          loadingContent: /*#__PURE__*/_jsx(Landmark, {
            icon: "spinner",
            height: 180
          }),
          children: /*#__PURE__*/_jsxs(Stack, {
            spacing: "m",
            children: [/*#__PURE__*/_jsx(CommentAvatarWrapper, {
              pictureUrl: userProfile === null || userProfile === void 0 ? void 0 : userProfile.pictureUrl,
              children: /*#__PURE__*/_jsx(CommentForm, {
                inputLabel: t('comment_form_label'),
                submitButtonLabel: t('actions_post'),
                submitSuccessMessage: t('alert_comment_posted_success'),
                submissionStatus: submissionStatus,
                onResetSubmitStatus: function onResetSubmitStatus() {
                  return setSubmissionStatus('idle');
                },
                onSubmit: submitComment,
                size: size
              })
            }), (comments === null || comments === void 0 ? void 0 : comments.length) === 0 ? /*#__PURE__*/_jsxs(Landmark, {
              icon: "chat",
              height: 180,
              children: [/*#__PURE__*/_jsx(Text, {
                bold: true,
                display: "block",
                children: t('empty_start_the_discussion')
              }), t('empty_no_comments')]
            }) : comments === null || comments === void 0 ? void 0 : comments.map(function (comment) {
              return userProfile && comment && /*#__PURE__*/_jsx(Comment, {
                comment: comment,
                user: userProfile,
                size: size
              }, comment === null || comment === void 0 ? void 0 : comment.id);
            }), hasNextPage && fetchNextPage && /*#__PURE__*/_jsx(Box, {
              pl: 42,
              children: /*#__PURE__*/_jsx(Button, {
                onClick: function onClick() {
                  return fetchNextPage();
                },
                isDisabled: areCommentsLoading,
                size: "medium",
                children: t('comments_more_comments')
              })
            })]
          })
        })]
      })
    })
  });
}
export default Comments;